var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleon_mobile_files_icon"},[_c('div',{},[_c('VueSkeletonLoader',{attrs:{"type":"rect","width":20,"height":15,"animation":"fade"}})],1),_c('div',{},[_c('VueSkeletonLoader',{attrs:{"type":"rect","width":50,"height":15,"animation":"fade"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }